module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-6.svg?e57e2fedfa5eb961fa772979c174733a";